var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ReactSelect from 'react-select';
import { Currency, Entity } from '@debbie/common/dist';
import { CaseStatus, CaseTag, SystemEndReason, EndReasonId, } from '@debbie/common/dist/cases';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers';
import { RegularFeeVoucherTypes } from '@debbie/common/dist/economy/vouchers/setup';
import { InteractionType } from '@debbie/common/dist/interactions';
import { TodoType, } from '@debbie/common/dist/workflows';
import { c, h } from '@debbie/cortex/dist';
import { useConnectConnectionsFrom } from '@debbie/cortex/dist/connect';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors';
import { selectMe } from '@debbie/cortex/dist/me/selectors';
import { selectTemplates } from '@debbie/cortex/dist/templates/selectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import Checkbox from '../Checkbox';
import { X } from '../Icons';
import Input from '../Input';
import SearchInput from '../SearchInput';
import Select from '../Select';
import Well from '../Well';
import { defaultMergeRules, RelationType, } from '@debbie/common/dist/customers';
import ExclusiveContent from '../ExclusiveContent';
import { usePropertyTypes } from '@debbie/cortex/dist/properties';
import CaseGroupSearch from '../search/CaseGroupSearch';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups';
import MergeCaseRules from '../MergeCaseRules';
import { objectBy } from '@debbie/common/dist/util';
import { useAllCollectors } from '@debbie/cortex/dist/collectors';
const templateInteractionMap = {
    [InteractionType.AutoCall]: 'autocall',
    [InteractionType.SMS]: 'sms',
    [InteractionType.Letter]: 'letter',
    [InteractionType.Email]: 'email',
    [InteractionType.Eboks]: 'eboks',
    [InteractionType.Kivra]: 'eboks',
    [InteractionType.Digipost]: 'eboks',
};
const getTemplateTypeFromInteractionType = (interactionType) => {
    const templateType = templateInteractionMap[interactionType];
    if (!templateType) {
        throw new Error('Not handled interaction type in template/interaction map');
    }
    return templateType;
};
const ProcedureCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const templates = useSelector(selectTemplates);
    const collectorsLoadable = useAllCollectors();
    const collectors = h.hasData(collectorsLoadable)
        ? collectorsLoadable.data
        : null;
    const collectorsMap = (collectors &&
        objectBy(collectors, (collector) => collector.collectorId)) ||
        {};
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const me = useSelector(selectMe);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const workflows = useSelector(selectWorkflows);
    const fromConnections = useConnectConnectionsFrom();
    const endReasons = useEndReasons();
    const [selectableTemplates, setSelectableTemplates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [todoType, setTodoType] = useState(TodoType.AddVoucher);
    const [voucherTypeId, setVoucherTypeId] = useState(VoucherTypeIds.REMINDERFEE);
    const [billingVoucherTypeId, setBillingVoucherTypeId] = useState(RegularFeeVoucherTypes[0]);
    const [text, setText] = useState('');
    const [amount, setAmount] = useState('100');
    const [imposedByCreditor, setImposedByCreditor] = useState(false);
    const [interactionType, setInteractionType] = useState(InteractionType.Email);
    const [sendImmediatelyDeviateFromSettings, setSendImmediatelyDeviateFromSettings,] = useState(false);
    const [sendImmediately, setSendImmediately] = useState(undefined);
    const [creditorInteractionType, setCreditorInteractionType] = useState(InteractionType.Email);
    const [includeVoucherAttachments, setIncludeVoucherAttachments] = useState(true);
    const [attachmentTemplateIds, setAttachmentTemplateIds] = useState([]);
    const [templateId, setTemplateId] = useState('');
    const [collectorId, setCollectorId] = useState(null);
    const [collector, setCollector] = useState('');
    const [caseGroupId, setCaseGroupId] = useState(null);
    const [caseTag, setCaseTag] = useState(CaseTag.SURVEILLANCE);
    const [endReasonId, setEndReasonId] = useState(EndReasonId[SystemEndReason.Paid]);
    const [useCreditorCollector, setUseCreditorCollector] = useState(false);
    const [setAsPrincipalReferenceCaseVoucher, setAsPrincipalreferenceVoucher] = useState(undefined);
    const [maxTotalAmount, setMaxTotalAmount] = useState(undefined);
    const [bespokeName, setBespokeName] = useState('');
    const [toWorkflowId, setToWorkflowId] = useState(null);
    const [mergeWithRelatedCases, setMergeWithRelatedCases] = useState([]);
    const [customCaseMergeRules, setCustomCaseMergeRules] = useState(undefined);
    useEffect(() => {
        if (!workflows) {
            c.workflows.getAll();
        }
    }, []);
    useEffect(() => {
        if (templates && !selectableTemplates) {
            const templateTypeMap = {};
            for (let i = 0; i < templates.length; i++) {
                const template = templates[i];
                templateTypeMap[template.type] = Object.assign(Object.assign({}, templateTypeMap[template.type]), { [template.templateId]: template.name });
            }
            setSelectableTemplates(Object.entries(templateTypeMap).reduce((acc, [templateType, templateMap]) => {
                acc[templateType] = Object.entries(templateMap).map(([templateId, name]) => ({
                    templateId,
                    name,
                }));
                return acc;
            }, {}));
        }
    }, [templates]);
    const getTodo = (details) => ({
        id: crypto.randomUUID(),
        type: todoType,
        details,
    });
    const add = (todoDetails) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield props.onCreate(getTodo(todoDetails));
        }
        catch (error) {
            alert(error);
            console.error(error);
        }
        setLoading(false);
    });
    const isExclusiveContent = me && (exclusiveContent === null || exclusiveContent === void 0 ? void 0 : exclusiveContent.includes(me.id));
    return (React.createElement(ProcedureBuilderStyled, null,
        React.createElement(Select, { value: todoType, onChange: (e) => {
                setTodoType(e.target.value);
                setTemplateId('');
            } }, Object.values(TodoType)
            .filter((type) => {
            if ([TodoType.MoveToTenant].includes(type)) {
                return false;
            }
            return isExclusiveContent
                ? true
                : ![
                    TodoType.ConnectToDebtCollector,
                    TodoType.Bespoke,
                    TodoType.SetCollector,
                ].includes(type);
        })
            .map((type) => (React.createElement("option", { key: type, value: type }, lang.workflowTodoTypes[type])))),
        React.createElement(Well, null, (() => {
            switch (todoType) {
                case TodoType.AddVoucher:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: voucherTypeId, onChange: (e) => {
                                setVoucherTypeId(e.target.value);
                            } }, [
                            VoucherTypeIds.REMINDERFEE,
                            VoucherTypeIds.COLLECTIONCOST,
                            VoucherTypeIds.COLLECTIONFEE,
                            VoucherTypeIds.PROCESSINTEREST,
                            VoucherTypeIds.GLPROCESSINTEREST,
                            VoucherTypeIds.COMPENSATIONCOST,
                            VoucherTypeIds.CONTROLFEE,
                        ].map((_voucherTypeId) => (React.createElement("option", { key: _voucherTypeId, value: _voucherTypeId }, lang.economyVoucherTypeLabels[_voucherTypeId])))),
                        ![
                            VoucherTypeIds.GLPROCESSINTEREST,
                            VoucherTypeIds.PROCESSINTEREST,
                            VoucherTypeIds.COLLECTIONCOST,
                        ].includes(voucherTypeId) && (React.createElement(React.Fragment, null,
                            React.createElement(Input, { value: amount, type: "number", onChange: (e) => {
                                    setAmount(e.target.value);
                                }, placeholder: lang.workflows.amount }),
                            React.createElement(Checkbox, { placeholder: lang.workflows.setAsPrincipalReferenceCaseVoucher, checked: setAsPrincipalReferenceCaseVoucher, onChange: (e) => {
                                    setAsPrincipalreferenceVoucher(e.target.checked ? true : undefined);
                                } }),
                            React.createElement(Checkbox, { placeholder: lang.workflows.setMaxTotalAmount, onChange: (e) => {
                                    setMaxTotalAmount(e.target.checked ? '300' : undefined);
                                } }),
                            maxTotalAmount !== undefined && (React.createElement(Input, { value: maxTotalAmount, type: "number", onChange: (e) => {
                                    setMaxTotalAmount(e.target.value);
                                }, placeholder: lang.workflows.maxTotalAmount })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.imposedByCreditor, checked: imposedByCreditor, onChange: (e) => {
                                setImposedByCreditor(e.target.checked);
                            } }),
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    voucherTypeId,
                                    currency: (tenant && tenant.currency) || Currency.DKK,
                                    imposedByCreditor,
                                    setAsPrincipalReferenceCaseVoucher,
                                    maxTotalAmount: maxTotalAmount &&
                                        ![
                                            VoucherTypeIds.GLPROCESSINTEREST,
                                            VoucherTypeIds.PROCESSINTEREST,
                                            VoucherTypeIds.COLLECTIONCOST,
                                        ].includes(voucherTypeId) &&
                                        Math.round(parseFloat(maxTotalAmount) * 100),
                                    amount: ![
                                        VoucherTypeIds.GLPROCESSINTEREST,
                                        VoucherTypeIds.PROCESSINTEREST,
                                        VoucherTypeIds.COLLECTIONCOST,
                                    ].includes(voucherTypeId) &&
                                        Math.round(parseFloat(amount) * 100),
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.AddBillingVoucher:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: billingVoucherTypeId, onChange: (e) => {
                                setBillingVoucherTypeId(e.target.value);
                            } }, [...RegularFeeVoucherTypes].map((_voucherTypeId) => (React.createElement("option", { key: _voucherTypeId, value: _voucherTypeId }, lang.economyVoucherTypeLabels[_voucherTypeId])))),
                        React.createElement(Input, { value: amount, type: "number", onChange: (e) => {
                                setAmount(e.target.value);
                            }, placeholder: lang.workflows.amount }),
                        React.createElement(Input, { placeholder: lang.workflows.text, value: text, onChange: (e) => {
                                setText(e.target.value);
                            } }),
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    voucherTypeId: billingVoucherTypeId,
                                    currency: (tenant && tenant.currency) || Currency.DKK,
                                    text,
                                    amount: Math.round(parseFloat(amount) * 100),
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.RemoveVoucher:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: voucherTypeId, onChange: (e) => {
                                setVoucherTypeId(e.target.value);
                            } }, [
                            VoucherTypeIds.REMINDERFEE,
                            VoucherTypeIds.COLLECTIONCOST,
                            VoucherTypeIds.COLLECTIONFEE,
                            VoucherTypeIds.GLPROCESSINTEREST,
                            VoucherTypeIds.PROCESSINTEREST,
                            VoucherTypeIds.COMPENSATIONCOST,
                            VoucherTypeIds.ADMINISTRATIONCOST,
                            VoucherTypeIds.INVOICE,
                        ].map((voucherTypeId) => (React.createElement("option", { key: voucherTypeId, value: voucherTypeId }, lang.economyVoucherTypeLabels[voucherTypeId])))),
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    voucherTypeId,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.CreateInteraction:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: interactionType, onChange: (e) => {
                                setInteractionType(e.target.value);
                                setTemplateId('');
                            } }, [
                            InteractionType.Email,
                            InteractionType.Letter,
                            InteractionType.SMS,
                            InteractionType.AutoCall,
                            InteractionType.Eboks,
                            InteractionType.EInvoice,
                            InteractionType.Kivra,
                            InteractionType.Digipost,
                        ]
                            .filter((type) => {
                            return isExclusiveContent
                                ? true
                                : ![
                                    InteractionType.Kivra,
                                    InteractionType.Digipost,
                                ].includes(type);
                        })
                            .map((interactionType) => (React.createElement("option", { key: interactionType, value: interactionType }, lang.interactionTypes[interactionType])))),
                        interactionType !== InteractionType.EInvoice && (React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)] &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)].filter((_template) => !q ||
                                    JSON.stringify(_template)
                                        .toLocaleLowerCase()
                                        .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                []).map((_template) => ({
                                heading: _template.name,
                                key: _template.templateId,
                                returnData: _template.templateId,
                            })), onSelect: (_templateId) => {
                                setTemplateId(_templateId);
                            }, cacheResetTrigger: interactionType, static: templateId &&
                                (() => {
                                    const _templates = selectableTemplates &&
                                        selectableTemplates[getTemplateTypeFromInteractionType(interactionType)];
                                    const template = _templates &&
                                        _templates.find((t) => t.templateId === templateId);
                                    return template ? template.name : templateId;
                                })(), onRemoveStatic: () => {
                                setTemplateId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectTemplate })),
                        interactionType === InteractionType.Email && (React.createElement("div", null,
                            React.createElement(Checkbox, { checked: includeVoucherAttachments, onChange: (e) => {
                                    setIncludeVoucherAttachments(e.target.checked);
                                }, placeholder: lang.workflows.includeVoucherAttachments }),
                            React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                    selectableTemplates.letter &&
                                    selectableTemplates.letter.filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: _template.templateId,
                                })), cacheResetTrigger: interactionType, onSelect: (_templateId) => {
                                    setAttachmentTemplateIds(attachmentTemplateIds.concat(_templateId));
                                }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectEmailPDFAttachment }),
                            React.createElement("div", null, attachmentTemplateIds.map((_templateId, i) => {
                                const template = selectableTemplates &&
                                    selectableTemplates.letter.find((t) => t.templateId === _templateId);
                                return (React.createElement("p", { key: _templateId, style: { margin: '0 0 1em 0' } },
                                    i + 1,
                                    ")",
                                    ' ',
                                    React.createElement("b", null, template ? template.name : _templateId),
                                    React.createElement(X, { onClick: () => {
                                            setAttachmentTemplateIds(attachmentTemplateIds.filter((_, index) => i !== index));
                                        }, style: {
                                            float: 'right',
                                            cursor: 'pointer',
                                        } })));
                            })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.sendImmediatelyDeviateFromSettings, checked: sendImmediatelyDeviateFromSettings, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setSendImmediately(true);
                                }
                                else {
                                    setSendImmediately(undefined);
                                }
                                setSendImmediatelyDeviateFromSettings(checked);
                            } }),
                        sendImmediatelyDeviateFromSettings && (React.createElement("div", null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "mini", theme: !sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(true);
                                    } }, lang.workflows.sendImmediately),
                                React.createElement(Button, { size: "mini", theme: sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(false);
                                    } }, lang.workflows.doNotSendImmediately)),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                        React.createElement(Button, { loading: loading, disabled: !(interactionType === InteractionType.EInvoice ||
                                templateId), onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    type: interactionType,
                                    templateId,
                                    includeVoucherAttachments: interactionType === InteractionType.Email &&
                                        includeVoucherAttachments,
                                    attachments: interactionType === InteractionType.Email &&
                                        attachmentTemplateIds.map((id) => ({
                                            templateId: id,
                                        })),
                                    sendImmediately,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.CreateCreditorInteraction:
                    return (React.createElement("div", null,
                        React.createElement(Select, { value: creditorInteractionType, onChange: (e) => {
                                setCreditorInteractionType(e.target.value);
                            } }, [InteractionType.Email].map((_interactionType) => (React.createElement("option", { key: _interactionType, value: _interactionType }, lang.interactionTypes[_interactionType])))),
                        React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)] &&
                                selectableTemplates[getTemplateTypeFromInteractionType(interactionType)].filter((_template) => !q ||
                                    JSON.stringify(_template)
                                        .toLocaleLowerCase()
                                        .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                []).map((_template) => ({
                                heading: _template.name,
                                key: _template.templateId,
                                returnData: _template.templateId,
                            })), onSelect: (_templateId) => {
                                setTemplateId(_templateId);
                            }, cacheResetTrigger: interactionType, static: templateId &&
                                (() => {
                                    const _templates = selectableTemplates &&
                                        selectableTemplates[getTemplateTypeFromInteractionType(interactionType)];
                                    const template = _templates &&
                                        _templates.find((t) => t.templateId === templateId);
                                    return template ? template.name : templateId;
                                })(), onRemoveStatic: () => {
                                setTemplateId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectTemplate }),
                        interactionType === InteractionType.Email && (React.createElement("div", null,
                            React.createElement(Checkbox, { checked: includeVoucherAttachments, onChange: (e) => {
                                    setIncludeVoucherAttachments(e.target.checked);
                                }, placeholder: lang.workflows.includeVoucherAttachments }),
                            React.createElement(SearchInput, { searchAll: (q) => ((selectableTemplates &&
                                    selectableTemplates.letter &&
                                    selectableTemplates.letter.filter((_template) => !q ||
                                        JSON.stringify(_template)
                                            .toLocaleLowerCase()
                                            .indexOf(q.toLocaleLowerCase()) !== -1)) ||
                                    []).map((_template) => ({
                                    heading: _template.name,
                                    key: _template.templateId,
                                    returnData: _template.templateId,
                                })), cacheResetTrigger: interactionType, onSelect: (_templateId) => {
                                    setAttachmentTemplateIds(attachmentTemplateIds.concat(_templateId));
                                }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectEmailPDFAttachment }),
                            React.createElement("div", null, attachmentTemplateIds.map((_templateId, i) => {
                                const template = selectableTemplates &&
                                    selectableTemplates.letter.find((t) => t.templateId === _templateId);
                                return (React.createElement("p", { key: _templateId, style: { margin: '0 0 1em 0' } },
                                    i + 1,
                                    ")",
                                    ' ',
                                    React.createElement("b", null, template ? template.name : _templateId),
                                    React.createElement(X, { onClick: () => {
                                            setAttachmentTemplateIds(attachmentTemplateIds.filter((_, index) => i !== index));
                                        }, style: {
                                            float: 'right',
                                            cursor: 'pointer',
                                        } })));
                            })))),
                        React.createElement(Checkbox, { placeholder: lang.workflows.sendImmediatelyDeviateFromSettings, checked: sendImmediatelyDeviateFromSettings, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setSendImmediately(true);
                                }
                                else {
                                    setSendImmediately(undefined);
                                }
                                setSendImmediatelyDeviateFromSettings(checked);
                            } }),
                        sendImmediatelyDeviateFromSettings && (React.createElement("div", null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "mini", theme: !sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(true);
                                    } }, lang.workflows.sendImmediately),
                                React.createElement(Button, { size: "mini", theme: sendImmediately ? 'secondary' : undefined, onClick: () => {
                                        setSendImmediately(false);
                                    } }, lang.workflows.doNotSendImmediately)),
                            React.createElement("br", null),
                            React.createElement("br", null))),
                        React.createElement(Button, { loading: loading, disabled: !templateId, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    type: creditorInteractionType,
                                    templateId,
                                    includeVoucherAttachments: interactionType === InteractionType.Email &&
                                        includeVoucherAttachments,
                                    attachments: interactionType === InteractionType.Email &&
                                        attachmentTemplateIds.map((id) => ({
                                            templateId: id,
                                        })),
                                    sendImmediately,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCollector:
                    return (React.createElement("div", null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.useCreditorCollector, onChange: (e) => {
                                setUseCreditorCollector(e.target.checked);
                                setCollectorId('');
                            }, checked: useCreditorCollector }),
                        React.createElement(SearchInput, { searchAll: (q) => (collectors || [])
                                .filter((collector) => !q ||
                                JSON.stringify(collector)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)
                                .map((_collector) => ({
                                heading: _collector.name,
                                subheading: `${lang.collectorTypes[_collector.type]}${_collector.email ? ` - ${_collector.email}` : ''}`,
                                key: _collector.collectorId,
                                returnData: _collector.collectorId,
                            })), cacheResetTrigger: todoType, disabled: useCreditorCollector, onSelect: (_collectorId) => {
                                setCollectorId(_collectorId);
                            }, static: collectorId &&
                                (() => {
                                    const collector = collectorsMap[collectorId];
                                    return collector
                                        ? `${collector.name} (${lang.collectorTypes[collector.type]}${collector.email ? ` - ${collector.email}` : ''})`
                                        : collectorId;
                                })(), onRemoveStatic: () => {
                                setCollectorId('');
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectCollector }),
                        React.createElement(Button, { loading: loading, disabled: !collectorId && !useCreditorCollector, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    collectorId,
                                    useCreditor: useCreditorCollector || undefined,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCaseGroup:
                    return (React.createElement("div", null,
                        React.createElement(SearchInput, { searchAll: (q) => (caseGroups || [])
                                .filter((caseGroup) => !q ||
                                JSON.stringify(caseGroup)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)
                                .map((_caseGroup) => ({
                                heading: _caseGroup.label,
                                key: _caseGroup.id,
                                returnData: _caseGroup.id,
                            })), cacheResetTrigger: todoType, onSelect: (_caseGroupId) => {
                                setCaseGroupId(_caseGroupId);
                            }, static: caseGroupId &&
                                (() => {
                                    const caseGroup = (caseGroups || []).find((caseGroup) => caseGroup.id === caseGroupId);
                                    return caseGroup ? caseGroup.label : caseGroupId;
                                })(), onRemoveStatic: () => {
                                setCaseGroupId(null);
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.selectCaseGroup }),
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    caseGroupId,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.ConnectToDebtCollector:
                    return (React.createElement("div", null,
                        React.createElement(Select, { onChange: (e) => {
                                setCollector(e.target.value);
                            }, value: collector },
                            React.createElement("option", null, "-- V\u00E6lg inddriver --"),
                            h.hasData(fromConnections)
                                ? fromConnections.data.map((conn) => {
                                    return (React.createElement("option", { key: conn.id, value: conn.id }, conn.product.name));
                                })
                                : null),
                        React.createElement(Button, { loading: loading, disabled: !collector, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    connectionId: collector,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.SetCaseTag:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Select, { value: caseTag, onChange: (e) => {
                                setCaseTag(e.target.value);
                            } },
                            React.createElement("option", { value: CaseTag.SURVEILLANCE }, lang.caseTags[CaseTag.SURVEILLANCE])),
                        React.createElement(Button, { loading: loading, disabled: !caseTag, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    tag: caseTag,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.ChangeCaseStatus:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Select, { value: endReasonId, onChange: (e) => {
                                setEndReasonId(e.target.value);
                            } }, (h.hasData(endReasons) ? endReasons.data : []).map((reason) => {
                            var _a;
                            return (React.createElement("option", { key: reason.id, value: reason.id }, (_a = lang.endReason[reason.handle]) !== null && _a !== void 0 ? _a : reason.label));
                        })),
                        React.createElement(Button, { loading: loading, disabled: !caseTag, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    status: CaseStatus.ENDED,
                                    endReasonId,
                                });
                            }) }, lang.workflows.addTodo)));
                case TodoType.SwitchWorkflow:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(SearchInput, { searchAll: (q) => (workflows || [])
                                .filter((workflow) => !q ||
                                JSON.stringify(workflow)
                                    .toLocaleLowerCase()
                                    .indexOf(q.toLocaleLowerCase()) !== -1)
                                .map((_workflow) => ({
                                heading: _workflow.title,
                                subheading: _workflow.description,
                                key: _workflow.workflowId,
                                returnData: _workflow.workflowId,
                            })), cacheResetTrigger: todoType, onSelect: (_workflowId) => {
                                setToWorkflowId(_workflowId);
                            }, static: toWorkflowId &&
                                (() => {
                                    const workflow = workflows === null || workflows === void 0 ? void 0 : workflows.find((workflow) => workflow.workflowId === toWorkflowId);
                                    return workflow ? `${workflow.title}` : toWorkflowId;
                                })(), onRemoveStatic: () => {
                                setToWorkflowId(null);
                            }, searchDelay: 0, forceOpen: true, placeholder: lang.workflows.workflows }),
                        React.createElement(Button, { loading: loading, disabled: !toWorkflowId, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                add({
                                    toWorkflowId,
                                });
                                setToWorkflowId(null);
                            }) }, lang.workflows.addTodo)));
                case TodoType.SwitchBackToPreviousWorkflow:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () { return add({}); }) }, lang.workflows.addTodo)));
                case TodoType.MergeCase:
                    return (React.createElement(React.Fragment, null,
                        React.createElement("p", null, lang.workflows.mergeCaseTodoDescription),
                        React.createElement(ReactSelect, { value: mergeWithRelatedCases.map((relationType) => {
                                return {
                                    label: lang.customerCaseRelationType[relationType],
                                    value: relationType,
                                };
                            }), isMulti: true, placeholder: lang.workflows.mergeWithRelatedCasesOfType, classNamePrefix: "select", options: Object.values(RelationType).map((relationType) => {
                                return {
                                    label: lang.customerCaseRelationType[relationType],
                                    value: relationType,
                                };
                            }), onChange: (val) => __awaiter(void 0, void 0, void 0, function* () {
                                const selected = val ? val.map((v) => v.value) : [];
                                setMergeWithRelatedCases(selected);
                            }) }),
                        React.createElement("br", null),
                        React.createElement(Checkbox, { placeholder: lang.workflows.applyCustomMergeRules, checked: !!customCaseMergeRules, onChange: (e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                    setCustomCaseMergeRules(defaultMergeRules);
                                }
                                else {
                                    setCustomCaseMergeRules(undefined);
                                }
                            } }),
                        !!customCaseMergeRules && (React.createElement(MergeCaseRules, { onChange: (mergeRules) => setCustomCaseMergeRules(mergeRules), rules: customCaseMergeRules })),
                        React.createElement("br", null),
                        React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                add({
                                    mergeWithRelatedCases,
                                    caseMergeRules: customCaseMergeRules,
                                });
                                setCustomCaseMergeRules(undefined);
                            }) }, lang.workflows.addTodo)));
                case TodoType.CreateProperties: {
                    return (React.createElement(CreateProperties, { loading: loading, add: add }));
                }
                case TodoType.Bespoke:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Input, { placeholder: "Name", value: bespokeName, onChange: (e) => {
                                setBespokeName(e.target.value);
                            } }),
                        React.createElement(Button, { loading: loading, disabled: !bespokeName, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                return add({
                                    name: bespokeName,
                                });
                            }) }, lang.workflows.addTodo)));
                default:
                    return (React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () { return add({}); }) }, lang.workflows.addTodo));
            }
        })())));
};
export default ProcedureCreator;
const ProcedureBuilderStyled = styled.div `
  text-align: left;

  & > h3 {
    font-size: 14px;
    margin-top: 0.5em;
  }
`;
const CreateProperties = (props) => {
    const lang = useSelector((s) => s.lang);
    const [propertyRef, setPropertyRef] = useState(Entity.CaseVoucher);
    const [scope, setScope] = useState('case_groups');
    const [scopeId, setScopeId] = useState(null);
    const propertyTypesLoader = usePropertyTypes();
    const [overwrite, setOverWrite] = useState(false);
    const [propertyId, setPropertyId] = useState('');
    const [value, setValue] = useState('NOW()');
    const [filter, setFilter] = useState({
        type: 'category',
        voucherCategory: VoucherCategory.PRINCIPAL,
    });
    return (React.createElement(ExclusiveContent, { fallback: () => React.createElement("p", null, "Coming soon") },
        React.createElement(Select, { value: propertyRef, onChange: (e) => setPropertyRef(e.currentTarget.value) },
            React.createElement("option", { key: "case", value: "case" }, "Case"),
            React.createElement("option", { key: "case-voucher", value: "case-voucher" }, "Case vouchers")),
        React.createElement(CaseGroupSearch, { selected: scopeId, onSelect: setScopeId }),
        h.hasData(propertyTypesLoader) ? (React.createElement(Select, { value: propertyId, onChange: (e) => setPropertyId(e.currentTarget.value) },
            React.createElement("option", { key: "", value: '' }),
            propertyTypesLoader.data.map((propertyType) => {
                return (React.createElement("option", { key: propertyType.propertyTypeId, value: propertyType.propertyTypeId }, propertyType.label));
            }))) : null,
        React.createElement(Button, { disabled: propertyId == '' || value == null, loading: props.loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                if (propertyId == '' || value == null) {
                    return;
                }
                if (propertyRef === Entity.Case) {
                    return props.add({
                        propertyRef,
                        overwrite,
                        propertyTypeId: propertyId,
                        value: value,
                    });
                }
                else if (propertyRef === Entity.CaseVoucher) {
                    return props.add({
                        propertyRef,
                        overwrite,
                        propertyTypeId: propertyId,
                        value: value,
                        filter: filter,
                    });
                }
            }) }, lang.workflows.addTodo)));
};
//# sourceMappingURL=ProcedureCreator.js.map